import React from "react"
import clsx from "clsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Checkbox = ({ checked, indeterminate, disabled, onChange, label, className, onDark }) => (
  <button
    type         = "button"
    role         = "checkbox"
    aria-checked = {indeterminate ? "mixed" : !!checked}
    aria-label   = {label}
    title        = {label}
    disabled     = {disabled}
    onClick      = {e => { e.stopPropagation(); onChange(!checked) }}
    className    = {clsx(
      "inline-grid place-items-center shrink-0 w-[16px] h-[16px] rounded-[4px] border transition-colors",
      "disabled:opacity-40 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-[3px] focus-visible:ring-brand-500/30",
      checked || indeterminate
        ? "bg-brand-500 border-brand-500 text-white"
        : onDark ? "bg-white/90 border-white text-transparent" : "bg-white border-slate-300 hover:border-brand-500 text-transparent",
      className
    )}
  >
    <FontAwesomeIcon icon={indeterminate ? "minus" : "check"} className="text-[9px]" />
  </button>
)

export default Checkbox
